import React, { useState, useCallback, useEffect } from "react";
import {
  useTransition,
  animated,
  useSpringRef,
  easings,
} from "@react-spring/web";
import Box from "@mui/material/Box";
import styles from "../style/diagnosiss.css";
import QuestionCard from "../components/QuestionCard";
import { Helmet } from "react-helmet";
import Head from "../components/Head";
import { easing } from "@mui/material";
import BoxTypo from "../components/BoxTypo";
/********/
import { styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import NativeSelect from "@mui/material/NativeSelect";
import InputBase from "@mui/material/InputBase";
/********/
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}));

const granolaType = {
  typeA: { id: 1, name: "heel" },
  typeB: "typeB",
  typeC: "",
};
const ansType = {
  pullDown: "pullDown",
  radioButton: "radioButton",
  buttonGroup: "buttonGroup",
  result: "result",
  start: "start",
};
const questions = [
  {
    text: "スタート画面",
    type: ansType.start,
    label: "",
    choices: [],
  },
  {
    text: "年齢を\n教えて下さい",
    type: ansType.pullDown,
    label: "年齢",
    choices: [
      { text: "10代", negative: [], positive: [] },
      { text: "20代", negative: [], positive: [] },
      { text: "30代", negative: [], positive: [] },
      { text: "40代", negative: [], positive: [] },
      { text: "50代", negative: [], positive: [] },
      { text: "60代以上", negative: [], positive: [] },
    ],
  },
  {
    text: "性別を教えて下さい",
    type: ansType.buttonGroup,
    choices: [
      { text: "男性", negative: [], positive: [] },
      { text: "女性", negative: [], positive: [] },
      { text: "その他", negative: [], positive: [] },
    ],
  },
  {
    text: "ドライフルーツ入りの\nグラノーラは好きですか？",
    type: ansType.radioButton,
    choices: [
      { text: "好き", negative: [], positive: [] },
      { text: "どちらでもない", negative: [], positive: [] },
      { text: "嫌い", negative: [], positive: [] },
    ],
  },
  {
    text: "塩気のある\nグラノーラは好きですか？",
    type: ansType.radioButton,
    choices: [
      { text: "好き", negative: [], positive: [] },
      { text: "どちらでもない", negative: [], positive: [] },
      { text: "嫌い", negative: [], positive: [] },
    ],
  },
  {
    text: "積極的に摂りたい\n栄養素はありますか？",
    label: "栄養",
    type: ansType.pullDown,
    choices: [
      { text: "オートミール", negative: [], positive: [] },
      { text: "ビタミンC", negative: [], positive: [] },
      { text: "タンパク質", negative: [], positive: [] },
      { text: "ビタミンB群", negative: [], positive: [] },
      { text: "クエン酸・アミノ酸", negative: [], positive: [] },
      { text: "食物繊維", negative: [], positive: [] },
    ],
  },
  {
    text: "最も困っている\n悩みを教えてください",
    label: "悩み",
    type: ansType.pullDown,
    choices: [
      { text: "とくに悩みはない", negative: [], positive: [] },
      { text: "便秘", negative: [], positive: [] },
      { text: "太ってきた", negative: [], positive: [] },
      { text: "肌荒れ", negative: [], positive: [] },
    ],
  },
];

const pages = [
  ({ style }) => (
    <animated.div style={{ ...style, background: "lightpink" }}>
      <QuestionCard question="紺にtは" questionNumber="1" />
    </animated.div>
  ),
  ({ style }) => (
    <animated.div style={{ ...style, background: "lightblue" }}>
      <QuestionCard question="test" questionNumber="2" />
    </animated.div>
  ),
  ({ style }) => (
    <animated.div style={{ ...style, background: "lightgreen" }}>
      <QuestionCard question="test" questionNumber="3" />
    </animated.div>
  ),
];

const Diagnosis = () => {
  const [index, setIndex] = useState(0);
  const [hiddenResult, setHiddenResult] = useState(true);
  const [isForward, setForward] = useState(true);
  // const onClick = useCallback((tempIsForward = true) => {
  //   .log(tempIsForward);
  //   set((state) => (state + 1) % questions.length);
  // }, []);
  const transRef = useSpringRef();
  const backTransRef = useSpringRef();
  const fromTransform3d = "translate3d(100%,0,0)";
  const leaveTransform3d = "translate3d(-50%,0,0)";

  const switchDirection = () => { };

  // const transitions = useTransition(index, {
  //   ref: transRef,
  //   keys: null,
  //   reverse: true,
  //   // config: { duration: 1500, easing: easing.easeInOutBounce },
  //   config: {
  //     duration: 2000,
  //     easing: easings.easeInOutQuad,
  //   },
  //   from: {
  //     opacity: 0,
  //     transform: isForward ? fromTransform3d : leaveTransform3d,
  //   },
  //   enter: { opacity: 1, transform: "translate3d(0%,0,0)" },
  //   leave: {
  //     opacity: 0,
  //     transform: isForward ? leaveTransform3d : fromTransform3d,
  //   },
  // });
  const transitions = useTransition(index, {
    ref: transRef,
    keys: null,
    reverse: true,
    // config: { duration: 1500, easing: easing.easeInOutBounce },
    config: {
      duration: 2000,
      easing: easings.easeInOutQuad,
    },
    from: {
      opacity: 0,
    },
    enter: { opacity: 1 },
    leave: {
      opacity: 0,
    },
  });
  useEffect(() => {
    transRef.start();
  }, [index]);

  return (
    <Box>
      <Head />

      {/* className={`flex fill container`} */}
      <div className={`flex fill container`} style={{ overflow: "hidden" }}>
        {transitions((style, i) => {
          return (
            <animated.div
              key={i}
              style={{ ...style, backgroundColor: "#F5EFE6" }}
            >
              <QuestionCard
                type={questions[i].type}
                choices={questions[i].choices}
                label={questions[i].label}
                question={questions[i].text}
                questionNumber={i}
                setIndex={setIndex}
                totalLength={questions.length}
                hiddenResult={hiddenResult}
                setHiddenResult={setHiddenResult}
              />
            </animated.div>
          );
        })}
      </div>
    </Box>
  );
};

export default Diagnosis;
